import React, { useContext, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import GlobalStyles from "@mui/material/GlobalStyles";

import ColorModeContext from "../context/ColorMode/ColorModeContext";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import DashboardGeneral from "../pages/DashboardGeneral/";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup/";
import Forget from "../pages/Forget/";

import Restore from "../pages/Restore";

import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import CallHistory from "../pages/CallHistory/";
import AiCosts from "../pages/AiCosts/";
import AiReplies from "../pages/AiReplies/";
import CallMetrics from "../pages/CallMetrics/";
import SettingsCustom from "../pages/SettingsCustom/";
import Financeiro from "../pages/Financeiro/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import MessagesAPI from "../pages/MessagesAPI/";
import Helps from "../pages/Helps/";
import ContactLists from "../pages/ContactLists/";
import ContactListItems from "../pages/ContactListItems/";
import QuickMessages from "../pages/QuickMessages/";
import TemplateMessage from "../pages/TemplateMessage/";
import AdCampaigns from "../pages/AdCampaigns/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { PublicRoute, PrivateRoute } from "./Route";
import Schedules from "../pages/Schedules";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Subscription from "../pages/Subscription/";
import Auditor from '../pages/Auditor'

import Prompts from "../pages/Prompts";
import QueueIntegration from "../pages/QueueIntegration";
import Kanban from "../pages/Kanban";
import KanbanContact from "../pages/KanbanContact";
import ToDoList from "../pages/ToDoList/";
import Activity from "../pages/ActivityLog";
import WhatsappManager from "../pages/WhatsappManager";
import Testing from "../pages/Testing";
import DataSources from "../pages/DataSources";
import Knowledge from "../pages/Knowledge";
import KnowledgeReview from "../pages/Knowledge/Review";
import OpenChat from "../pages/OpenChat";

const PrivateLayout = () => (
  <PrivateRoute>
    <WhatsAppsProvider>
      <LoggedInLayout>
        <Outlet />
      </LoggedInLayout>
    </WhatsAppsProvider>
  </PrivateRoute>
);

const AppRoutes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);
  const { mode } = useContext(ColorModeContext);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <TicketsContextProvider>
          <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/signup" element={<PublicRoute><Signup /></PublicRoute>} />
            <Route path="/forget" element={<PublicRoute><Forget /></PublicRoute>} />
            <Route path="/restore" element={<PublicRoute><Restore /></PublicRoute>} />

            <Route element={<PrivateLayout />}>
              <Route path="/" element={<DashboardGeneral />} />
              <Route path="/auditor" element={<Auditor />} />
              <Route path="/todolist" element={<ToDoList />} />
              <Route path="/tickets/:ticketId?" element={<TicketResponsiveContainer />} />
              <Route path="/send" element={<OpenChat />} />
              <Route path="/connections" element={<Connections />} />
              <Route path="/calls/history" element={<CallHistory />} />
              <Route path="/calls/metrics" element={<CallMetrics />} />
              <Route path="/ai-costs" element={<AiCosts />} />
              <Route path="/ai-replies" element={<AiReplies />} />
              <Route path="/analytics" element={<WhatsappManager />} />
              <Route path="/ad-campaigns" element={<AdCampaigns />} />
              <Route path="/quick-messages" element={<QuickMessages />} />
              <Route path="/template-message" element={<TemplateMessage />} />
              <Route path="/schedules" element={<Schedules />} />
              <Route path="/tags" element={<Tags />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/helps" element={<Helps />} />
              <Route path="/users" element={<Users />} />
              <Route path="/messages-api" element={<MessagesAPI />} />
              <Route path="/testing" element={<Testing />} />
              <Route path="/data-sources" element={<DataSources />} />
              <Route path="/knowledge" element={<Knowledge />} />
              <Route path="/knowledge/:documentId" element={<KnowledgeReview />} />
              <Route path="/prompts" element={<Prompts />} />
              <Route path="/queue-integration" element={<QueueIntegration />} />
              <Route path="/activity" element={<Activity />} />
              <Route path="/settings" element={<SettingsCustom />} />
              <Route path="/kanban" element={<Kanban />} />
              <Route path="/kanbanContact" element={<KanbanContact />} />
              <Route path="/financeiro" element={<Financeiro />} />
              <Route path="/queues" element={<Queues />} />
              <Route path="/announcements" element={<Annoucements />} />
              <Route path="/subscription" element={<Subscription />} />
              <Route path="/chats/:id?" element={<Chat />} />
              {showCampaigns && (
                <>
                  <Route path="/contact-lists" element={<ContactLists />} />
                  <Route path="/contact-lists/:contactListId/contacts" element={<ContactListItems />} />
                  <Route path="/campaigns" element={<Campaigns />} />
                  <Route path="/campaign/:campaignId/report" element={<CampaignReport />} />
                  <Route path="/campaigns-config" element={<CampaignsConfig />} />
                </>
              )}
              {}
              <Route path="*" element={<></>} />
            </Route>
          </Routes>
          <Toaster
            position="top-right"
            theme={mode}
            richColors
            closeButton
            expand
            gap={12}
            offset={18}
            duration={3500}
            toastOptions={{
              style: {
                borderRadius: 14,
                padding: "14px 16px",
                fontSize: 14,
                fontWeight: 600,
                boxShadow:
                  mode === "light"
                    ? "0 10px 30px rgba(16,24,40,0.16)"
                    : "0 10px 30px rgba(0,0,0,0.55)",
                gap: 12,
              },
            }}
          />
          <GlobalStyles
            styles={{
              "[data-sonner-toast]": {
                alignItems: "center",
              },
              "[data-sonner-toast] [data-icon]": {
                width: 22,
                height: 22,
                marginRight: 12,
              },
              "[data-sonner-toast] [data-icon] > svg": {
                width: 22,
                height: 22,
              },
              "[data-sonner-toast] [data-title]": {
                fontWeight: 600,
                letterSpacing: 0.1,
                lineHeight: 1.35,
              },
              "[data-sonner-toast] [data-close-button]": {
                borderRadius: 8,
                transition: "transform .15s ease",
              },
              "[data-sonner-toast] [data-close-button]:hover": {
                transform: "scale(1.1)",
              },
            }}
          />
        </TicketsContextProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppRoutes;
